import React from 'react';
import { useOnboardingStore } from '../stores/onboarding-store';
import CustomerFormFields from './CustomerFormFields';
import ProductSelectionForm from './ProductSelectionForm';
import {CustomerType} from "@/shared/api/model";

interface BusinessOnboardingFormProps {
  categoryId: number;
  currentStep: number;
}

const BusinessOnboardingForm: React.FC<BusinessOnboardingFormProps> = ({
  categoryId,
  currentStep,
}) => {
  const {
    formData,
    updateFieldValue,
    updateFormData,
    errors,
  } = useOnboardingStore();

  const handleFieldChange = (fieldName: string, value: any) => {
    updateFieldValue('customerData', fieldName, value);
  };

  const handleProductsChange = (products: any[]) => {
    updateFormData('productData', products);
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0: // Business Information
        return (
          <CustomerFormFields
            categoryId={categoryId}
            customerType={CustomerType.BUSINESS}
            formData={formData.customerData}
            onFieldChange={handleFieldChange}
            errors={errors}
          />
        );

      case 1: // Signatories
        return (
          <div className="signatory-management-placeholder">
            <h4>Authorized Signatories</h4>
            <p>Signatory management component will be integrated here.</p>
          </div>
        );

      case 2: // Shareholders
        return (
          <div className="shareholder-management-placeholder">
            <h4>Shareholders</h4>
            <p>Shareholder management component will be integrated here.</p>
          </div>
        );

      case 3: // Directors
        return (
          <div className="director-management-placeholder">
            <h4>Company Directors</h4>
            <p>Director management component will be integrated here.</p>
          </div>
        );

      case 4: // Product Selection
        return (
          <ProductSelectionForm
            categoryProducts={[]}
            selectedProducts={formData.productData}
            onProductsChange={handleProductsChange}
            errors={errors}
          />
        );

      case 5: // Documents
        return (
          <div className="document-upload-placeholder">
            <h4>Document Upload</h4>
            <p>Business document upload component will be integrated here.</p>
          </div>
        );

      case 6: // Locations
        return (
          <div className="location-form-placeholder">
            <h4>Address Information</h4>
            <p>Business location management component will be integrated here.</p>
          </div>
        );

      case 7: // Review
        return (
          <div className="review-form-placeholder">
            <h4>Review & Submit</h4>
            <p>Review component showing all business information will be here.</p>
            <pre>{JSON.stringify(formData, null, 2)}</pre>
          </div>
        );

      default:
        return <div>Unknown step</div>;
    }
  };

  return (
    <div className="business-onboarding-form">
      {renderStepContent()}
    </div>
  );
};

export default BusinessOnboardingForm;
